import { hasActualValue } from '@core/utils/form-utils'

/** Formats an ISO date string as `dd.MM.yyyy`; unparsable input is returned unchanged. */
export function formatDisplayDate(value: string | null | undefined): string | null {
  if (!hasActualValue(value)) return null
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return value
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = date.getFullYear()
  return `${day}.${month}.${year}`
}
